<template>
  <div class="control-timeline">
    <!-- legend title -->
    <legend-title icon-name="hand-pointer" title="Select year" class="control-timeline__title" />

    <!-- divider -->
    <div class="control-timeline__divider" />

    <div class="control-timeline__items">
      <div
        v-for="item in items"
        :key="item"
        :data-value="item"
        :class="{ 'timeline-item--active': item === lazyValue }"
        class="timeline-item dtm-button"
        :button_name="taggingAttr"
        @click="updateLazyValue"
      >
        <!-- step -->
        <div :data-value="item" class="timeline-item__step" />

        <!-- label -->
        <div :data-value="item" class="timeline-item__label text-legend text--darkgrey">{{ item }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import LegendTitle from '@/components/ui/LegendTitle.vue';

export default {
  name: 'ControlTimeline',
  components: {
    LegendTitle,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    value: null,
    taggingAttr: String,
  },
  data() {
    return {
      lazyValue: this.value,
    };
  },
  methods: {
    updateLazyValue(e) {
      // get selected value
      const { value } = e.target.dataset;

      // update value
      this.lazyValue = value;

      // emit value
      this.$emit('input', this.lazyValue);
    },
  },
};
</script>

<style lang="scss" scoped>
.control-timeline {
  margin: 20px 0;

  .control-timeline__title {
    margin-bottom: 15px;
  }

  .control-timeline__divider {
    width: 100%;
    height: 1px;
    background-color: rgba(0, 0, 0, 0.12);
    margin-top: 5px;
  }

  .control-timeline__items {
    display: flex;
    justify-content: space-between;
    margin-top: -5px;

    .timeline-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      cursor: pointer;

      .timeline-item__step {
        width: 10px;
        height: 10px;
        background-color: #a9a8a9;
        border-radius: 99px;
        margin-bottom: 10px;
      }

      &--active {
        .timeline-item__step {
          border: none;
          background-color: #e1091d;
          transform: scale(1);
          box-shadow: 0 0 0 0 rgba(225, 9, 29, 1);
          animation: pulse 1.5s infinite;
        }
      }
    }
  }
}
</style>
